export const RESET_RECORD_EDITOR_NEW = 'RESET_RECORD_EDITOR_NEW';

export function resetRecordEditorNew() {
    return {
        type: RESET_RECORD_EDITOR_NEW
    }
}